import React from "react";
import { useNavigate } from "react-router-dom";

import {
    AppBar,
    Toolbar,
    Drawer,
    Box,
    Typography,
    IconButton,
    Divider,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Collapse,
    Button,
    Tooltip,
} from "@mui/material";

import MenuIcon from "@mui/icons-material/Menu";
import HomeIcon from "@mui/icons-material/Home";
import WebIcon from "@mui/icons-material/Web";
import CodeIcon from "@mui/icons-material/Code";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LogoutIcon from "@mui/icons-material/Logout";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import NewspaperOutlinedIcon from "@mui/icons-material/NewspaperOutlined";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import EventOutlinedIcon from "@mui/icons-material/EventOutlined";
import logo from "../../assets/img/img.png";
import { useAuth } from "../../hooks/UserContext";
const drawerWidth = 260;
const collapsedWidth = 72;

const SuperAdminLayout = ({ children }) => {
    const navigate = useNavigate();
    const { logout } = useAuth();

    const [mobileOpen, setMobileOpen] = React.useState(false);

    // Estado del sidebar
    const [collapsed, setCollapsed] = React.useState(false);

    const [openAntilen, setOpenAntilen] = React.useState(true);

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const handleCollapse = () => {
        setCollapsed(!collapsed);
    };

    const handleLogout = () => {
        logout();
        navigate("/login");
    };

    const handleNavigate = (path) => {
        navigate(path);
        setMobileOpen(false);
    };

    /*
    ============================================================
    SIDEBAR
    ============================================================
    */

    const drawer = (
        <Box
            sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
            }}
        >

            {/* HEADER DEL SIDEBAR */}
            <Box
                sx={{
                    height: 64,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: collapsed
                        ? "center"
                        : "flex-start",
                    px: collapsed ? 1 : 2,
                }}
            >

               <Box
    sx={{
        width: 60,
        height: 60,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
    }}
>
    <Box
        component="img"
        src={logo}
        alt="Logo Colegio Antilen"
        sx={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
        }}
    />
</Box>

              
              
            </Box>

            <Divider
                sx={{
                    borderColor:
                        "rgba(255,255,255,0.1)",
                }}
            />

            {/* MENU */}
          <List
    sx={{
        px: collapsed ? 1 : 1,
        pt: 2,
    }}
>
    {/* =========================
        INICIO
    ========================= */}

    <AdminMenuItem
        collapsed={collapsed}
        icon={<HomeIcon />}
        title="Inicio"
        onClick={() =>
            handleNavigate("/admin/antilen")
        }
    />


    {/* =========================
        NOTICIAS
    ========================= */}

    <AdminMenuItem
        collapsed={collapsed}
        icon={<NewspaperOutlinedIcon />}
        title="Noticias"
        onClick={() =>
            handleNavigate("/admin/noticias")
        }
    />


    {/* =========================
        BANNER
    ========================= */}

    <AdminMenuItem
        collapsed={collapsed}
        icon={<ImageOutlinedIcon />}
        title="Banner"
        onClick={() =>
            handleNavigate("/admin/banner")
        }
    />


    {/* =========================
        HORARIOS
    ========================= */}

    <AdminMenuItem
        collapsed={collapsed}
        icon={<AccessTimeOutlinedIcon />}
        title="Horarios"
        onClick={() =>
            handleNavigate("/admin/horarios")
        }
    />


    {/* =========================
        REGLAMENTOS
    ========================= */}

    <AdminMenuItem
        collapsed={collapsed}
        icon={<DescriptionOutlinedIcon />}
        title="Reglamentos"
        onClick={() =>
            handleNavigate("/admin/reglamentos")
        }
    />


    {/* =========================
        COMUNIDAD
    ========================= */}

    <AdminMenuItem
        collapsed={collapsed}
        icon={<GroupsOutlinedIcon />}
        title="Comunidad"
        onClick={() =>
            handleNavigate("/admin/comunidad")
        }
    />


    {/* =========================
        AGENDA
    ========================= */}

    <AdminMenuItem
        collapsed={collapsed}
        icon={<EventOutlinedIcon />}
        title="Agenda"
        onClick={() =>
            handleNavigate("/admin/agenda")
        }
    />

</List>

            {/* CERRAR SESIÓN */}
            <Box
                sx={{
                    mt: "auto",
                    p: collapsed ? 1 : 2,
                }}
            >

                <Divider
                    sx={{
                        mb: 2,
                        borderColor:
                            "rgba(255,255,255,0.1)",
                    }}
                />

                <Tooltip
                    title={
                        collapsed
                            ? "Cerrar sesión"
                            : ""
                    }
                    placement="right"
                >

                    <Button
                        fullWidth
                        variant="outlined"
                        startIcon={
                            <LogoutIcon />
                        }
                        onClick={handleLogout}
                        sx={{
                            minWidth: 0,

                            color: "#ffffff",

                            borderColor:
                                "rgba(255,255,255,0.3)",

                            textTransform: "none",

                            borderRadius: 2,

                            justifyContent:
                                collapsed
                                    ? "center"
                                    : "flex-start",

                            px: collapsed ? 1 : 2,

                            "& .MuiButton-startIcon": {
                                margin:
                                    collapsed
                                        ? 0
                                        : undefined,
                            },

                            "&:hover": {
                                borderColor:
                                    "#ffffff",

                                backgroundColor:
                                    "rgba(255,255,255,0.08)",
                            },
                        }}
                    >

                        {!collapsed && (
                            "Cerrar sesión"
                        )}

                    </Button>

                </Tooltip>

            </Box>

        </Box>
    );

    /*
    ============================================================
    LAYOUT
    ============================================================
    */

    return (
        <Box
            sx={{
                display: "flex",
                minHeight: "100vh",
                backgroundColor: "#f5f6f8",
            }}
        >

            {/* APP BAR */}

            <AppBar
                position="fixed"
                elevation={0}
                sx={{
                    width: {
                        md: `calc(100% - ${
                            collapsed
                                ? collapsedWidth
                                : drawerWidth
                        }px)`,
                    },

                    ml: {
                        md: `${
                            collapsed
                                ? collapsedWidth
                                : drawerWidth
                        }px`,
                    },

                    backgroundColor: "#561c33",

                    transition:
                        "width 0.2s, margin 0.2s",
                }}
            >

                <Toolbar>

                    {/* MOBILE */}
                    <IconButton
                        color="inherit"
                        edge="start"
                        onClick={handleDrawerToggle}
                        sx={{
                            mr: 2,
                            display: {
                                md: "none",
                            },
                        }}
                    >
                        <MenuIcon />
                    </IconButton>

                    {/* DESKTOP */}
                    <IconButton
                        color="inherit"
                        onClick={handleCollapse}
                        sx={{
                            display: {
                                xs: "none",
                                md: "flex",
                            },
                            mr: 2,
                        }}
                    >
                        {collapsed ? (
                            <ChevronRightIcon />
                        ) : (
                            <ChevronLeftIcon />
                        )}
                    </IconButton>

                    <Box sx={{ flexGrow: 1 }}>

                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 600,
                                fontSize: "1rem",
                            }}
                        >
                            Bienvenido Administrador
                        </Typography>

                        <Typography
                            sx={{
                                fontSize: "0.75rem",
                                color: "#B0B0B0",
                            }}
                        >
                            Colegio Antilen
                        </Typography>

                    </Box>

                </Toolbar>

            </AppBar>

            {/* DRAWER DESKTOP */}

            <Drawer
                variant="permanent"
                sx={{
                    display: {
                        xs: "none",
                        md: "block",
                    },

                    width: collapsed
                        ? collapsedWidth
                        : drawerWidth,

                    flexShrink: 0,

                    "& .MuiDrawer-paper": {
                        width: collapsed
                            ? collapsedWidth
                            : drawerWidth,

                        boxSizing:
                            "border-box",

                        backgroundColor:
                            "#561c33",

                        color: "#ffffff",

                        borderRight: "none",

                        transition:
                            "width 0.2s",

                        overflowX: "hidden",
                    },
                }}
                open
            >
                {drawer}
            </Drawer>

            {/* DRAWER MOBILE */}

            <Drawer
                variant="temporary"
                open={mobileOpen}
                onClose={handleDrawerToggle}
                ModalProps={{
                    keepMounted: true,
                }}
                sx={{
                    display: {
                        xs: "block",
                        md: "none",
                    },

                    "& .MuiDrawer-paper": {
                        width: drawerWidth,

                        backgroundColor:
                            "#561c33",

                        color: "#ffffff",
                    },
                }}
            >
                {drawer}
            </Drawer>

            {/* CONTENIDO */}

            <Box
                component="main"
                sx={{
                    flexGrow: 1,

                    width: {
                        md: `calc(100% - ${
                            collapsed
                                ? collapsedWidth
                                : drawerWidth
                        }px)`,
                    },

                    mt: "64px",

                    p: {
                        xs: 2,
                        md: 3,
                    },

                    transition:
                        "width 0.2s",
                }}
            >
                {children}
            </Box>

        </Box>
    );
};

export default SuperAdminLayout;

const AdminMenuItem = ({
    collapsed,
    icon,
    title,
    onClick,
}) => {
    return (
        <ListItem
            disablePadding
            sx={{
                display: "block",
                mb: 0.5,
            }}
        >
            <Tooltip
                title={collapsed ? title : ""}
                placement="right"
                arrow
            >
                <ListItemButton
                    onClick={onClick}
                    sx={{
                        minHeight: 48,

                        justifyContent: collapsed
                            ? "center"
                            : "initial",

                        px: collapsed ? 1 : 2,

                        borderRadius: 2,

                        color: "#ffffff",

                        "&:hover": {
                            backgroundColor:
                                "rgba(255,255,255,0.08)",
                        },

                        "&.active": {
                            backgroundColor:
                                "rgba(255,255,255,0.12)",
                        },
                    }}
                >

                    <ListItemIcon
                        sx={{
                            minWidth: 0,

                            mr: collapsed
                                ? 0
                                : 2,

                            justifyContent:
                                "center",

                            color: "#ffffff",
                        }}
                    >
                        {icon}
                    </ListItemIcon>

                    {!collapsed && (
                        <ListItemText
                            primary={title}
                            primaryTypographyProps={{
                                fontSize: "0.9rem",
                                fontWeight: 500,
                            }}
                        />
                    )}

                </ListItemButton>
            </Tooltip>
        </ListItem>
    );
};